import Reveal from "./Reveal";

const features = [
  { icon: "fa-chart-line", title: "Live Dashboard", desc: "District-wise and dealer-wise bag movement, fraud alerts and consumption maps — refreshed every 5 seconds." },
  { icon: "fa-mobile-screen", title: "Zero App Farmer Scan", desc: "Browser-based form opens on QR scan. Works on the cheapest 2G feature phones with camera." },
  { icon: "fa-robot", title: "AI Fraud Detection", desc: "Anomaly engine flags duplicate, out-of-zone or rapid-fire scans automatically before they propagate." },
  { icon: "fa-file-arrow-up", title: "Flexible Excel Import", desc: "Companies push manifests in any column order. Auto-mapping ingests millions of bags in minutes." },
  { icon: "fa-print", title: "QR Print Manager", desc: "Batch-generate GS1-128 codes with rollback-safe sequence locking — ready for factory printers." },
  { icon: "fa-comment-sms", title: "Multi-language SMS", desc: "Hindi, Marathi, Tamil, Telugu, Bengali, Punjabi & 8 more — confirmation SMS to farmer in seconds." },
];

export default function Features() {
  return (
    <section className="section" id="features" data-testid="features-section">
      <div className="section-inner">
        <div className="features-header">
          <Reveal>
            <span className="section-eyebrow">Platform Capabilities</span>
            <h2 className="section-heading">
              Built for scale. <em>Designed</em> for the field.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="section-desc">
              Every module is meant for traceability of Fertilizers so that it reaches in
              right hands.
            </p>
          </Reveal>
        </div>

        <div className="features-grid">
          {features.map((f, i) => (
            <Reveal key={f.title} delay={i * 80}>
              <div className="feature-card" data-testid={`feature-card-${i}`}>
                <div className="feature-icon">
                  <i className={`fa-solid ${f.icon}`}></i>
                </div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
                <a href="#how" className="feature-link">
                  Learn more <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
